import {useTranslation } from "react-i18next"
import Navbar from "../../common/navbar/Navbar"; 

const Home = () => {
    const [t,i18n] = useTranslation("global");
    const handleChangeLanguage = (lang) =>{
        i18n.changeLanguage(lang);
    }
    return (
        <>
            <Navbar />
            
            <div className="container"> 
            </div>
        </>
        
    )
}

export default Home